const bindings = [
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Zoom' },
    label: 'Zoom',
    keys: ['z'],
    isEditable: true,
  },
  {
    commandName: 'scaleUpViewport',
    label: 'Zoom In',
    keys: ['+'],
    isEditable: true,
  },
  {
    commandName: 'scaleDownViewport',
    label: 'Zoom Out',
    keys: ['-'],
    isEditable: true,
  },
  {
    commandName: 'fitViewportToWindow',
    label: 'Zoom to Fit',
    keys: ['='],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCW',
    label: 'Rotate Right',
    keys: ['r'],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCCW',
    label: 'Rotate Left',
    keys: ['l'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportHorizontal',
    label: 'Flip Horizontally',
    keys: ['h'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportVertical',
    label: 'Flip Vertically',
    keys: ['v'],
    isEditable: true,
  },
  {
    commandName: 'toggleCine',
    label: 'Cine',
    keys: ['c'],
  },
  {
    commandName: 'invertViewport',
    label: 'Invert',
    keys: ['i'],
    isEditable: true,
  },
  {
    commandName: 'incrementActiveViewport',
    label: 'Next Image Viewport',
    keys: ['right'],
    isEditable: true,
  },
  {
    commandName: 'decrementActiveViewport',
    label: 'Previous Image Viewport',
    keys: ['left'],
    isEditable: true,
  },
  {
    commandName: 'updateViewportDisplaySet',
    commandOptions: {
      direction: -1,
    },
    label: 'Previous Series',
    keys: ['pageup'],
    isEditable: true,
  },
  {
    commandName: 'updateViewportDisplaySet',
    commandOptions: {
      direction: 1,
    },
    label: 'Next Series',
    keys: ['pagedown'],
    isEditable: true,
  },
  {
    commandName: 'nextStage',
    context: 'DEFAULT',
    label: 'Next Stage',
    keys: ['.'],
    isEditable: true,
  },
  {
    commandName: 'previousStage',
    context: 'DEFAULT',
    label: 'Previous Stage',
    keys: [','],
    isEditable: true,
  },
  {
    commandName: 'nextImage',
    label: 'Next Image',
    keys: ['down'],
    isEditable: true,
  },
  {
    commandName: 'previousImage',
    label: 'Previous Image',
    keys: ['up'],
    isEditable: true,
  },
  {
    commandName: 'firstImage',
    label: 'First Image',
    keys: ['home'],
    isEditable: true,
  },
  {
    commandName: 'lastImage',
    label: 'Last Image',
    keys: ['end'],
    isEditable: true,
  },
  {
    commandName: 'resetViewport',
    label: 'Reset',
    keys: ['space'],
    isEditable: true,
  },
  {
    commandName: 'cancelMeasurement',
    label: 'Cancel Measurement',
    keys: ['esc'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-soft-tissue', presetIndex: 0 },
    label: 'W/L Preset 1',
    keys: ['1'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-lung', presetIndex: 1 },
    label: 'W/L Preset 2',
    keys: ['2'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-bone', presetIndex: 2 },
    label: 'W/L Preset 3',
    keys: ['3'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-brain', presetIndex: 3 },
    label: 'W/L Preset 4',
    keys: ['4'],
  },
  {
    commandName: 'deleteActiveAnnotation',
    label: 'Delete Annotation',
    keys: ['backspace'],
  },
  {
    commandName: 'acceptPreview',
    label: 'Accept Preview',
    keys: ['enter'],
  },
  {
    commandName: 'rejectPreview',
    label: 'Reject Preview',
    keys: ['esc'],
  },
  // after we have the ui for undo/redo, we can add these back in
  // {
  //   commandName: 'undo',
  //   label: 'Undo',
  //   keys: ['ctrl+z'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'redo',
  //   label: 'Redo',
  //   keys: ['ctrl+y'],
  //   isEditable: true,
  // },
  // epeople: adicionado todas as opções da toolbar nos atalhos
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'WindowLevel' },
    label: 'Window Level',
    keys: ['w'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Pan' },
    label: 'Pan',
    keys: ['p'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'StackScroll' },
    label: 'Stack Scroll',
    keys: ['s'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'TrackballRotate' },
    label: '3D Rotate',
    keys: ['t'],
    isEditable: true,
  },

  // ---- Ferramentas de medição/ROI ----
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Length' },
    label: 'Length',
    keys: ['shift+l'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Bidirectional' },
    label: 'Bidirectional',
    keys: ['shift+b'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'ArrowAnnotate' },
    label: 'Annotation',
    keys: ['shift+a'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'EllipticalROI' },
    label: 'Ellipse',
    keys: ['shift+e'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'RectangleROI' },
    label: 'Rectangle',
    keys: ['shift+r'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'CircleROI' },
    label: 'Circle',
    keys: ['shift+c'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'PlanarFreehandROI' },
    label: 'Freehand ROI',
    keys: ['shift+f'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'SplineROI' },
    label: 'Spline ROI',
    keys: ['shift+s'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'LivewireContour' },
    label: 'Livewire tool',
    keys: ['shift+w'],
    isEditable: true,
  },

  /* ---- Outras ferramentas de viewport ---- */
  {
    commandName: 'toggleEnabledDisabledToolbar',
    commandOptions: { id: 'ReferenceLines' },
    label: 'Reference Lines',
    keys: [';'],
    isEditable: true,
  },
  {
    commandName: 'toggleEnabledDisabledToolbar',
    commandOptions: { id: 'ImageOverlayViewer' },
    label: 'Image Overlay',
    keys: ['u'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Angle' },
    label: 'Angle',
    keys: ['g'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'CobbAngle' },
    label: 'Cobb Angle',
    keys: ['shift+g'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'CalibrationLine' },
    label: 'Calibration Line',
    keys: ['shift+k'],
    isEditable: true,
  },
  {
    commandName: 'openDICOMTagViewer',
    label: 'DICOM Tag Browser',
    keys: ['ctrl+d'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Magnify' },
    label: 'Magnify',
    keys: ['m'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'UltrasoundDirectional' },
    label: 'Ultrasound Directional',
    keys: ['ctrl+u'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'WindowLevelRegion' },
    label: 'Window Level Region',
    keys: ['shift+w'],
    isEditable: true,
  },

  /* ---- Presets de layout / Hanging Protocol ---- */

  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'mpr' },
    label: 'Layout: MPR',
    keys: ['alt+1'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'fourUp' },
    label: 'Layout: 3D four up',
    keys: ['alt+2'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'main3D' },
    label: 'Layout: 3D main',
    keys: ['alt+3'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'primaryAxial' },
    label: 'Layout: Axial Primary',
    keys: ['alt+4'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'only3D' },
    label: 'Layout: 3D only',
    keys: ['alt+5'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'primary3D' },
    label: 'Layout: 3D primary',
    keys: ['alt+6'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: '@ohif/frameView' },
    label: 'Layout: Frame View',
    keys: ['alt+7'],
    isEditable: true,
  },
  {
    commandName: 'setHangingProtocol',
    commandOptions: { protocolId: 'mipMinIp' },
    label: 'Layout: MIP / MinIP',
    keys: ['alt+8'],
    isEditable: true,
  }
];

export default bindings;
